<template>
  <div class="index-content2">
    <div class="title-container">
      <div class="title-dec-left">
        <img src="@/assets/image/title-dec.png" alt="title decoration left" />
      </div>
      <div class="title-text">特色功能，嗨爆现场</div>
      <div class="title-dec-right">
        <img src="@/assets/image/title-dec.png" alt="title decoration right" />
      </div>
    </div>

    <div class="card-show-container">
      <div
        v-for="(card, index) in cardList"
        :key="index"
        class="card"
      >
        <div class="card-image">
          <!-- 图片区域，后续再填充具体图片地址 -->
          <img
            v-if="card.cardImage"
            :src="card.cardImage"
            :alt="card.cardAlt"
          />
        </div>
        <div class="card-content">
          <div class="card-title-wrapper">
            <div class="card-title">
              {{ card.cardTitle }}
            </div>
          </div>
          <div class="tags">
            <div
              v-for="(tag, tagIndex) in card.cardContent"
              :key="tagIndex"
              class="tag"
            >
              {{ tag }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination-dots">
      <span
        v-for="dot in 3"
        :key="dot"
        class="dot"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndexContent2',
  data() {
    return {
      cardList: [
        {
          cardTitle: '扫码签到，祝福上墙',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/bemy_1767854163016c52f34.webp',
          cardAlt: '微信扫码签到送祝福',
          cardContent: ['签到', '心墙', '表白'],
        },
        {
          cardTitle: '礼物霸屏，金榜题名',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/lwbp_17678541983602baef5.webp',
          cardAlt: '礼物霸屏土豪专属',
          cardContent: ['特效', '照片', '赞赏'],
        },
        {
          cardTitle: '幸运抽奖，好运连连',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/xycj_1767854237120d14c0f.webp',
          cardAlt: '酒吧顾客参与现场抽奖',
          cardContent: ['头像抽奖', '名单抽奖', '照片抽奖'],
        },
        {
          cardTitle: '互动游戏，趣味加倍',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/hdyx_1767854271701e54374.webp',
          cardAlt: '经典大屏互动摇一摇赛车游戏',
          cardContent: ['摇一摇', '划一划', '点一点'],
        },
        {
          cardTitle: '荭包雨落，全场欢呼',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/hbyl_1767854303370e16eb8.webp',
          cardAlt: '经典大屏互动荭包雨游戏',
          cardContent: ['福利', '荭包', '好运'],
        },
        {
          cardTitle: '扫码点歌，唱出所爱',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/smdg_176785433360319aa0d.webp',
          cardAlt: '酒吧顾客扫码点歌方便快捷',
          cardContent: ['点歌', '打赏', '金曲'],
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.index-content2 {
  width: 100%;
  height: auto;
  margin-top: 72px;

  .card-show-container {
    width: 1155px; // 手动设置宽度，保证一行只展示三个卡片
    margin: 42px auto 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap; // 如果一行超过三个则自动换行
    justify-content: center;
    align-items: center;
    gap: 31px;

    .card {
      width: 363px;
      height: 294px;
      border-radius: 12px;
      border: 2px solid #C95EFB;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .card-image {
        width: 100%;
        height: 200px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
        }
      }

      .card-content {
        width: 100%;
        height: 94px;
        padding: 0px 0px;
        position: relative;
        background: linear-gradient(270deg, #4A20BA 0%, #9535BF 100%);

        .card-title-wrapper {
          width: 100%;

          .card-title {
            width: 230px;
            height: 37px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: 20px;
            color: #FFFFFF;
            border-radius: 8px;
            background-image: url('~@/assets/image/card-title.png');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }
        }

        .tags {
          width: 100%;
          margin-top: 10px;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          align-items: center;

          .tag {
            min-width: 70px;
            padding: 0 12px;
            height: 26px;
            border-radius: 13px;
            border: 1px solid #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            box-sizing: border-box;
          }
        }
      }
    }
  }

  .pagination-dots {
    margin: 46px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    .dot {
      width: 21px;
      height: 21px;
      border-radius: 50%;
      background: #ffffff;
      cursor: pointer;
      transition: all 0.2s ease;

      &.active {
        background: #ffffff;
        transform: scale(1.15);
      }
    }
  }

  .title-container {
    height: 43px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    gap: 12px;

    .title-dec-left {
      img {
        width: 75px;
        height: 26px;
        display: block;
        object-fit: contain;
      }
    }

    .title-text {
      font-weight: 700;
      font-size: 30px;
      color: #ffffff;
      align-self: flex-end;
      line-height: 1;
    }

    .title-dec-right {
      img {
        width: 75px;
        height: 26px;
        display: block;
        object-fit: contain;
        transform: scaleX(-1);
      }
    }
  }
}
</style>
